export const UNKNOWN = {code: 0, label: "UNKNOWN"};
export const DISABLED = {code: 1, label: "DISABLED"};
export const SEARCHING = {code: 2, label: "SEARCHING"};
export const CONNECTED = {code: 3, label: "CONNECTED"};
export const DISCONNECTED = {code: 4, label: "DISCONNECTED"};



// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/converter/enums/WifiStatusEnum.js